















































/* eslint-disable @typescript-eslint/camelcase */
import { Vue, Component } from "vue-property-decorator"
import { addNewMarket } from "@/store/types/actions"
import { GET_COMPANY_LIST, GET_COUNTRY_LIST } from "@/store/types/getters"
import { MarketModule, CompanyModule, CountryModule } from "@/consts"
import { isStringAndHasLength } from "@/utils/validate"
import { notifyError } from "@/utils/notify"
import { AddMarket, Company, Country } from "@/models"

@Component
export default class SCustomerForm extends Vue {
    private country_iso: string | null = null
    private company: string | null = null

    @CountryModule.Getter(GET_COUNTRY_LIST) countryList!: Country[]
    @CompanyModule.Getter(GET_COMPANY_LIST) companyList!: Company[]
    @MarketModule.Action(addNewMarket) addNewMarket!: (
        paylaod: AddMarket
    ) => void

    private get hasCompanyAndCountryIso() {
        return (
            isStringAndHasLength(this.company) &&
            isStringAndHasLength(this.country_iso)
        )
    }

    private onClose() {
        this.$modal.hide("SCustomerForm")
    }

    private onSubmit() {
        if (this.hasCompanyAndCountryIso) {
            this.addNewMarket({
                country_iso: this.country_iso,
                company: this.company,
            })
            this.onClose()
        } else {
            notifyError("Operation cancelled", "Please fill in the form")
        }
    }
}
